export const text = {
  DISABLED_ACCOUNT: 'Disabled account',
  ERROR: 'Error',
}
